/**
 * 公開LPの訴求コンテンツ。
 * Vertical別LPは「LPの見た目を業界風に変える」ものではなく、
 * 提供する業務成果・Knowledge・Quality Gateの違いを説明する（design §25.1）。
 */

export type VerticalContent = {
	key: string;
	name: string;
	tagline: string;
	outcome: string;
	/** 一言で言う「LP制作ではなく◯◯を提供する」の◯◯ */
	scope: string;
	knowledge: string[];
	gates: string[];
	kpis: string[];
	ucsIds: string[];
	priority: "重点" | "優先" | "次順位";
};

export const VERTICALS: VerticalContent[] = [
	{
		key: "beauty_clinic",
		name: "美容クリニック",
		tagline: "LPを作るのではなく、新規患者の獲得までを担当します",
		outcome: "新規患者・予約の獲得、Campaign運用、継続改善",
		scope: "新規患者獲得業務",
		knowledge: [
			"医療脱毛・美容整形・シミ治療などメニュー別の訴求とTarget",
			"医療広告ガイドラインと禁止表現、症例写真の掲載条件",
			"初回価格・回数・適用条件・税込表記のルール",
			"Web予約 / LINE / 電話の導線設計と商圏の考え方",
		],
		gates: [
			"医療広告表現チェック（LLM判定 + 根拠提示）",
			"価格・適用条件の正確性",
			"症例写真の掲載同意確認",
			"Mobileでの予約導線到達性",
		],
		kpis: ["予約CVR", "予約単価", "LINE登録率", "初診数への寄与"],
		ucsIds: ["UCS-WEB-010-01-v1"],
		priority: "重点",
	},
	{
		key: "restaurant",
		name: "飲食",
		tagline: "予約・来店・注文・再来店の獲得までを担当します",
		outcome: "来店・予約・注文の獲得、地域集客、再来店",
		scope: "予約・来店獲得業務",
		knowledge: [
			"業態別（レストラン / カフェ / 居酒屋 / ベーカリー）の訴求差",
			"Lunch・Dinner・宴会・記念日・観光需要とSeason",
			"予約条件、Cancel Policy、No-show、当日受付、待ち時間",
			"Allergen・食習慣・多言語対応と表示ルール",
		],
		gates: [
			"営業時間・定休日・住所・電話・価格・Menuの正確性",
			"予約 / 注文Linkの実動作",
			"Campaign終了日と自動停止・差替",
			"多言語内容と日本語正本の整合",
		],
		kpis: ["予約CVR", "電話 / Map / 注文クリック率", "予約単価", "No-show率"],
		ucsIds: ["UCS-WEB-020-01-v1"],
		priority: "重点",
	},
	{
		key: "ec_d2c",
		name: "EC / D2C",
		tagline: "広告からLP、購入、Upsell、Repeatまでを担当します",
		outcome: "商品獲得、購入Conversion、客単価、Repeat",
		scope: "販売Conversion改善業務",
		knowledge: [
			"商品Category、価格、原価、在庫、配送、定期購入、返品",
			"Offer設計とReview活用、Cart離脱の要因",
			"景品表示・特定商取引法まわりの表示要件",
		],
		gates: ["価格 / 在庫 / 送料 / 返品の整合", "訴求の根拠", "Cart動作", "法定表示の確認"],
		kpis: ["CVR", "AOV", "ROAS", "Repeat / LTV", "Cart abandonment"],
		ucsIds: [],
		priority: "優先",
	},
	{
		key: "real_estate",
		name: "不動産・住宅",
		tagline: "物件情報の運用から問い合わせ、追客までを担当します",
		outcome: "物件・査定・来場問い合わせ、商談化、追客",
		scope: "反響獲得と追客業務",
		knowledge: [
			"物件種別、商圏、価格、間取、設備、交通、学区",
			"来場・査定・融資の導線と情報の鮮度要件",
			"不動産広告の誇大表現規制",
		],
		gates: ["物件情報の鮮度", "価格 / 条件 / 面積の整合", "画像・図面の権利", "公開終了の自動処理"],
		kpis: ["問い合わせ数", "Qualified Lead率", "来場予約", "Cost per Lead"],
		ucsIds: [],
		priority: "優先",
	},
	{
		key: "recruit",
		name: "採用",
		tagline: "求人票を作るのではなく、応募から採用までを担当します",
		outcome: "応募獲得、候補者Qualify、面接化、採用広報改善",
		scope: "採用業務全体",
		knowledge: [
			"職種 / Skill / 給与 / 勤務条件 / EVP",
			"候補者Personaと採用競合",
			"差別的表現・誤認表現の規制",
		],
		gates: ["条件の整合", "差別 / 誤認表現", "必須・歓迎要件の妥当性", "応募フォームの動作"],
		kpis: ["応募数", "Qualified率", "面接化率", "Time / Cost per Hire"],
		ucsIds: [],
		priority: "優先",
	},
	{
		key: "b2b_saas",
		name: "B2B Service / SaaS",
		tagline: "LPから営業Pipelineまでをつなぎます",
		outcome: "資料請求、相談、Demo、MQL / SQL創出",
		scope: "Lead獲得とQualify業務",
		knowledge: ["ICP、Use Case、Pain、ROI、Security要件", "導入事例と比較軸", "契約・価格体系"],
		gates: ["主張と根拠", "事例掲載許諾", "Security表現", "Form / Consent / Routing"],
		kpis: ["MQL / SQL", "Demo数", "Pipeline", "Cost per Qualified Lead"],
		ucsIds: [],
		priority: "優先",
	},
	{
		key: "travel",
		name: "観光・宿泊",
		tagline: "多言語での予約獲得と地域送客までを担当します",
		outcome: "予約、訪日客対応、地域送客、Upsell",
		scope: "直販予約獲得業務",
		knowledge: ["Season、客室 / Plan、Availability、Cancel", "交通・体験・言語・文化"],
		gates: ["価格 / 空室 / 条件", "Cancel Policy", "翻訳整合", "予約動作"],
		kpis: ["Booking Conversion", "ADR", "Direct Booking率", "国 / 言語別CVR"],
		ucsIds: [],
		priority: "優先",
	},
];

export function findVertical(key: string): VerticalContent | undefined {
	return VERTICALS.find((v) => v.key === key);
}

export const LEGAL_PAGES: Record<
	string,
	{ title: string; sections: Array<{ heading: string; body: string }> }
> = {
	terms: {
		title: "利用規約",
		sections: [
			{
				heading: "第1条（適用）",
				body: "本規約は、Agentry（以下「本サービス」）の提供条件および当社と利用者との間の権利義務関係を定めるものです。本文書はPOC用のサンプルであり、実際の契約条件ではありません。",
			},
			{
				heading: "第2条（アカウント）",
				body: "利用者は、登録情報を正確に維持する責任を負います。認証情報の管理responsibilityは利用者に帰属します。",
			},
			{
				heading: "第3条（生成物の取り扱い）",
				body: "本サービスが生成した成果物の所有者は、生成時点のSession Ownerとします。所有者の変更は明示的な移管操作によってのみ行われます。",
			},
			{
				heading: "第4条（禁止事項）",
				body: "法令に違反する利用、第三者の権利を侵害する利用、本サービスの品質・安全機構を回避する利用を禁止します。",
			},
		],
	},
	privacy: {
		title: "プライバシーポリシー",
		sections: [
			{
				heading: "取得する情報",
				body: "アカウント情報、利用ログ、実行履歴、費用情報を取得します。API Key、Cookie、Tokenの本文は保存せず、Secret Managerへの参照のみを保持します。",
			},
			{
				heading: "利用目的",
				body: "サービス提供、品質改善、不正利用の防止、課金および監査のために利用します。",
			},
			{
				heading: "第三者提供",
				body: "AI Providerへの処理委託を行う場合があります。委託範囲はProvider Policyで管理し、許可されていない共有は行いません。",
			},
			{
				heading: "保存期間",
				body: "Session・成果物の保存期間はテナント設定に従います。期限を過ぎたデータは取得できなくなります。",
			},
		],
	},
	tokushoho: {
		title: "特定商取引法に基づく表記",
		sections: [
			{ heading: "販売事業者", body: "（POCサンプル）Agentry 運営事務局" },
			{ heading: "対価", body: "各プランの表示価格に従います。表示は税込です。" },
			{ heading: "支払時期・方法", body: "クレジットカードによる月次前払いです。" },
			{ heading: "提供時期", body: "決済完了後、直ちに利用可能になります。" },
		],
	},
	security: {
		title: "セキュリティ",
		sections: [
			{
				heading: "秘密情報の取り扱い",
				body: "API Key、Cookie、Tokenの本文はアプリケーションおよびデータベースへ平文保存しません。Secret Manager上の参照のみを保持し、登録後に再表示しません。",
			},
			{
				heading: "テナント分離",
				body: "すべてのAPIはテナント・プロジェクトのスコープを検証します。他テナントのリソースは存在自体を返しません。",
			},
			{
				heading: "監査",
				body: "設定変更、権限変更、認証操作、承認判断、所有者移管は監査ログへ記録されます。",
			},
			{
				heading: "実行環境",
				body: "実行環境は使い捨てです。長期の認証情報を実行環境へ保存せず、期限付きの利用権のみを配布します。",
			},
		],
	},
};
